import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

/* CSS */
import '../../../styles/stepper.css'

/* HOOKS */
import useInsertPublic from '../../../hooks/userInsertPublic';
import useSendEmail from "../../../hooks/useSendEmail";
import useUpdate from "../../../hooks/useUpdate";

/* USER */
import { useAuth } from '../../../contexts/AuthContext';



/* COMPONENTS */
import Stepper from './addwizard/stepper';
import Page1 from './addwizard/page1';
import Page2 from './addwizard/page2';
import Page3 from './addwizard/page3';
import Swal from 'sweetalert2';

import LoadingAnimation from '../../../components/Loading';
import RegistrationSuccessNotice from '../../../pages/RegistrationSuccessNotice';


// Main Wizard Form Component
function LawyerAddNoAuth() {

  const gotoPage=(page)=>{
    navigate(page);
  }


  const navigate = useNavigate();
  const { user } = useAuth();
  const lawyerId = user.user_id;
  const lawyerProfilePhoto = user.user_profile_photo

  const [loadingText,setLoadingText] = useState("Loading...");



  const [currentPage, setCurrentPage] = useState(1);
  const nextPage = () => setCurrentPage(currentPage + 1);
  const prevPage = () => setCurrentPage(currentPage - 1);
  const getTitleClass = (page) => (currentPage === page ? 'active' : '');





// ACCIDENTALLY REFRESH THE PAGE THEN IT WILL CACHE
const initialFormState = {

  // PAGE 1

  lawyerImageNotary: '',
  lawyerImageNotarySignature: '',
  lawyerFirstName: '',
  lawyerMiddleName: '',
  lawyerLastName: '',
  lawyerSuffix: '',
  lawyerBirthday: '',
  lawyerPlaceOfBirth: '',
  lawyerGender: '',
  lawyerCivilStatus: '',
  country: 'Philippines',
  region: '',
  province: '',
  cityMunicipality: '',
  barangay: '',
  lawyerContactNumber: '',
  lawyerEmail: '',

  lawyerPassword: '',
  lawyerConfirmPassword: '',
  lawyerFirstName: '',


  // PAGE 2
  lawyerNotaryName: '',
  lawyerNotaryRollNo: '',
  lawyerCommissionNo: '',
  lawyerCommissionExpiryDate: '',
  lawyerPTRNo: '',
  lawyerPTRDateIssued: '',
  lawyerPTRPlaceOfIssue: '',
  lawyerIBPNo: '',
  lawyerComplianceNo: '',
  lawyerComplianceDateIssued: '',
  lawyerNotarialEmail: '',
  lawyerNotarialAddress: '',

  uploadedFiles: [],
};


const [formData, setFormData] = useState(() => {
  const saved = localStorage.getItem('lawyerForm');
  return {
    ...initialFormState,
    ...(saved ? JSON.parse(saved) : {}),
  };
});

useEffect(() => {

  // THIS CODE LINE BELOW IS TO REMOVE THE DEFAULT VALUES WHEN ACCIDENTALY RELOAD
  //  const { lawyerPassword, lawyerConfirmPassword, ...safeFormData } = formData;

  const {...safeFormData } = formData;


  localStorage.setItem('lawyerForm', JSON.stringify(safeFormData));
}, [formData]);



const handleReset = () => {
  setFormData(initialFormState);
  localStorage.removeItem('lawyerForm');
};
  

/* HOOKS USAGE */
const { insertData, isLoading, errorMessage, successMessage, responseData } = useInsertPublic();
const { sendEmail, responseEmail, errorEmail } = useSendEmail();
const { updateData, isLoading:isLoadingUpdate, errorMessage:errorMessageUpdate, successMessage:successMessageUpdate, responseData:responseDataUpdate } = useUpdate('patch');


const [isSubmitting, setIsSubmitting] = useState(false);
const [successStatus, setSuccessStatus] = useState("")
 
const sendToEmail = async () => {
  setIsSubmitting(true);
  try {  
     const formDataEmail = new FormData();
      formDataEmail.append('released_by_id', lawyerId);
      formDataEmail.append('recipient_email', formData.email);
      const url = `${process.env.REACT_APP_API_URL}/transactions/upload_pdf/`;
        updateData(url, formDataEmail, (responseData) => {
        if (responseData) {
          setSuccessStatus(responseData.status);
          setIsSubmitting(false);
        }
      });
  } catch (error) {
    console.error('Error generating or uploading PDF:', error);
  }
};




  const saveData = async() => {

    console.log(formData.uploadedFiles);
 
        const result = await Swal.fire({
            title             : 'Save information ?',
            // text              : 'Do you want to proceed ?',
            icon              : 'warning',
            showCancelButton  : true,
            confirmButtonColor: 'btn-info',
            cancelButtonColor : 'btn-secondary',
            confirmButtonText : 'Yes, save!',
            cancelButtonText  : 'No, cancel',
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',
        });



        const lawyerBirthday            = formData.lawyerBirthday ? new Date(formData.lawyerBirthday).toLocaleDateString('en-CA', { timeZone: 'Asia/Manila', }) : '';
        const lawyerCommissionExpiryDate= formData.lawyerCommissionExpiryDate ? new Date(formData.lawyerCommissionExpiryDate).toLocaleDateString('en-CA', { timeZone: 'Asia/Manila', }) : '';
        const lawyerPTRDateIssued       = formData.lawyerPTRDateIssued ? new Date(formData.lawyerPTRDateIssued).toLocaleDateString('en-CA', { timeZone: 'Asia/Manila', }) : '';
        const lawyerComplianceDateIssued= formData.lawyerComplianceDateIssued ? new Date(formData.lawyerComplianceDateIssued).toLocaleDateString('en-CA', { timeZone: 'Asia/Manila', }) : '';


        const fullname = "";
 
    
        const finalFormData = {


          // PAGE 1
          lawyerImageNotary         : formData.lawyerImageNotary,
          lawyerImageNotarySignature: formData.lawyerImageNotarySignature,
          fullname                  : fullname,
          lawyerFirstName           : formData.lawyerFirstName,
          lawyerMiddleName          : formData.lawyerMiddleName ?? "",
          lawyerLastName            : formData.lawyerLastName,
          lawyerSuffix              : formData.lawyerSuffix ?? "",
          lawyerBirthday            : lawyerBirthday,
          lawyerPlaceOfBirth        : formData.lawyerPlaceOfBirth,
          lawyerGender              : formData.lawyerGender,
          lawyerCivilStatus         : formData.lawyerCivilStatus,
          country                   : 'Philippines',
          region                    : formData.region,
          province                  : formData.province,
          cityMunicipality          : formData.cityMunicipality,
          barangay                  : formData.barangay,
          address                   : formData.lawyerAddress,
          
          lawyerContactNumber       : formData.lawyerContactNumber,
          email                     : formData.lawyerEmail,


          // PAGE 2
          lawyerNotaryName          : formData.lawyerNotaryName,
          lawyerNotaryRollNo        : formData.lawyerNotaryRollNo,
          lawyerCommissionNo        : formData.lawyerCommissionNo,
          lawyerCommissionExpiryDate: lawyerCommissionExpiryDate,
          lawyerPTRNo               : formData.lawyerPTRNo,
          lawyerPTRDateIssued       : lawyerPTRDateIssued,
          lawyerPTRPlaceOfIssue     : formData.lawyerPTRPlaceOfIssue,
          lawyerIBPNo               : formData.lawyerIBPNo,
          lawyerComplianceNo        : formData.lawyerComplianceNo,
          lawyerComplianceDateIssued: lawyerComplianceDateIssued,
          lawyerNotarialEmail       : formData.lawyerNotarialEmail,
          lawyerNotarialAddress     : formData.lawyerNotarialAddress,

          uploadedFiles:formData.uploadedFiles,



          // // THIS IS REQUIRED FIELDS
          // transaction_status        : 'PENDING',
          // meeting_id                : '',
          // meeting_pass              : '',
          // transaction_payment_status: 'PAID',
          // document_price            : formData.amount,
          // document_attachment       : '',
          // user_location             : formData.region,
          // document_to_address       : `${formData.region}, ${formData.province}, ${formData.cityMunicipality}, ${formData.barangay}`,
          // created_by                : lawyerId,
          // updated_by                : lawyerId,
          // is_save                   : 1,
          // user_profile              : lawyerId,
       

          // // THIS ISNT REQUIRED FIELDS
          userTag:"LAWYER",
          userStatus:"NOT_VERIFIED",
          pinCode:"1234",
          username:formData.lawyerEmail,
          password:formData.lawyerPassword,
        //   password:"4321",

          
          // transaction_type         : "WALK-IN",
          // for_draft                : 0,
          // administrative_officer_id: lawyerId,
          // released_by_id           : lawyerId,
      };
        
      console.log(formData);
      console.log("finalFormData",finalFormData);
  
        if (result.isConfirmed) {
            setLoadingText("Saving application & Uploading Documents...");
            try {
               await insertData(`${process.env.REACT_APP_API_URL}/users/`, finalFormData, (responseData) => {
                    // navigate('/certificates/');
                  if(responseData.message==="success"){
                      localStorage.removeItem('lawyerForm');
                      setShowSaveButton(false);
                   }
               });
             

              } catch (error) {
                console.error("Error inserting data:", error);
              }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            console.log('Submission cancelled.');
          }

  };

  const [showSaveButton,setShowSaveButton] = useState(true);

 
  
useEffect(() => {
    if (errorMessage) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}, [errorMessage,successMessage]);


function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

 const prevPageChecker = usePrevious(currentPage);

useEffect(() => {
  if (prevPageChecker !== undefined && currentPage > prevPageChecker) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}, [currentPage, prevPageChecker]);

 

  return (
      <div className="container-xxl flex-grow-1 pt-3">
        <div className='d-flex flex-row justify-content-between'>
          <Link to="/login" className="btn btn-primary btn-sm rounded rounded-pill mb-2">Back to login</Link>
          <h4 className="">
            <span className="text-muted fw-light">Account Registration</span>
          </h4>
        </div>


        {isLoading && <LoadingAnimation text={loadingText} />}
        {!successMessage && errorMessage && (
          <div className="alert alert-danger">
             {errorMessage}
              {/* {typeof errorMessage === 'object'
                  ? Object.entries(errorMessage).map(([field, messages]) => (
                      <div key={field}>
                          <strong>{field.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong>{messages.join(', ')}
                      </div>
                    ))
                  : String(errorMessage)} */}
          </div>
      )}

      
        {successMessage && (
            <RegistrationSuccessNotice
                successMessage={successMessage}
                email={formData.lawyerEmail}
            />
        )}

          {!successMessage &&
              <div id="wizard-validation" className="bs-stepper mt-2 linear">

                  <Stepper getTitleClass={getTitleClass} currentPage={currentPage} />

                  <div className="bs-stepper-content">
                      {/* <button type='button' onClick={()=>setShowAcknowledgement(true)} >Open </button> */}

                      {currentPage === 1 && (
                          <Page1
                              formData={formData}
                              setFormData={setFormData}
                              nextPage={nextPage}
                          />
                      )}
                      {currentPage === 2 && (
                          <Page2
                              formData={formData}
                              setFormData={setFormData}
                              nextPage={nextPage}
                              prevPage={prevPage}
                          />
                      )}


                      {currentPage === 3 && (
                          <Page3
                              formData={formData}
                              setFormData={setFormData}
                              prevPage={prevPage}
                              saveData={saveData}
                              showSaveButton={showSaveButton}
                          />
                      )}


                  </div>
              </div>
          }

           <p className="text-center mt-4 pb-4 mb-0">
              <span>Already have an account?</span> <Link to="/login">Sign In</Link>
            </p>

      </div>
  );
}

export default LawyerAddNoAuth;
